const config = {
  apiUrl: import.meta.env.VITE_API_BASE_URL
};

console.log(config.apiUrl);

export default config;
